// @noflow
import messages from './intl';
import { PickerContainer } from './style';
import * as React from 'react';
import theme from '~/core/themes/main';
import WarmWhiteBulb from '~/components/bulbs/warm-white';

export const getValueColor = ({ value }) => (value.get('status') === 'OFF' ? theme.mediumGrey : theme.mainBrandColor);

export const getValueLabel = ({ formatMessage, value }) =>
    value.get('status') === 'OFF' ? formatMessage(messages.off) : `${value.get('brightness')}%`;

export const hasPicker = () => true;

export const getPicker = ({ config, value, updateValue }) => {
    const isOn = value.get('status') === 'ON';
    const toggleLightbulb = () => {
        isOn
            ? updateValue(value.clear().set('status', 'OFF'))
            : updateValue(
                  value.withMutations(value =>
                      value
                          .set('status', 'ON')
                          .set('brightness', config.getIn(['products', 'warmwhitelight', 'defaultBrightness']))
                  )
              );
    };
    const valueChanged = newValue => updateValue(value.set('brightness', newValue));
    return (
        <PickerContainer>
            <WarmWhiteBulb
                bulbBrightness={
                    value.get('brightness') || config.getIn(['products', 'warmwhitelight', 'defaultBrightness'])
                }
                isOn={isOn}
                isSmall
                toggleLightbulb={toggleLightbulb}
                valueChanged={valueChanged}
            />
        </PickerContainer>
    );
};

export const defaultEventValue = { status: 'OFF' };

export const getDefaultSchedule = () => ({
    monday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    tuesday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    wednesday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    thursday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    friday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    saturday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    sunday: [
        { value: { status: 'ON', brightness: 100 }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON', brightness: 100 }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ]
});



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/warm-white-light/index.js